/**
 * ScrapeStatusBadge Component
 *
 * Consistent badge styling for scrape status across the application.
 * Uses centralized configuration from badgeConfig.js to ensure consistency.
 */

import React from "react";
import { Badge } from "../Badge";
import PropTypes from "prop-types";
import { getScrapeStatusConfig } from "../../../tools/properties/badgeConfig";
import "./ScrapeStatusBadge.scss";

export const ScrapeStatusBadge = ({
  status,
  size = "medium",
  showIcon = true,
  className = "",
}) => {
  if (!status) return null;

  const config = getScrapeStatusConfig(status);
  const Icon = showIcon && config.icon ? config.icon : null;

  return (
    <Badge
      variant={config.variant}
      size={size}
      className={`scrape-status-badge ${className}`}
    >
      {Icon && <Icon style={{ marginRight: "0.25rem" }} />}
      {config.label}
    </Badge>
  );
};

ScrapeStatusBadge.propTypes = {
  status: PropTypes.string.isRequired,
  size: PropTypes.oneOf(["small", "medium", "large"]),
  showIcon: PropTypes.bool,
  className: PropTypes.string,
};

export default ScrapeStatusBadge;
